import { getBffUrl as bffUrlSelector } from 'selectors'
import store from '../store'

import * as Api from '../utils/api'

const getBffUrl = () => bffUrlSelector(store.getState())

export const createGaioProject = body => Api.post(
  `${getBffUrl()}/gaio/projects`,
  body
)

export const updateGaioProject = (id, body) => Api.patch(
  `${getBffUrl()}/gaio/projects/${id}`,
  body
)

export const deleteGaioProject = id => Api.destroy(
  `${getBffUrl()}/gaio/projects/${id}`
)

export const searchGaioProjects = body => Api.post(
  `${getBffUrl()}/gaio/projects/search`,
  body
)

export const fetchGaioProjectsCount = () => Api.get(
  `${getBffUrl()}/gaio/projects/count`
)

export const searchGaioPrompts = body => Api.post(
  `${getBffUrl()}/gaio/prompts/search`,
  body
)

export const fetchGaioPromptsStatistics = () => Api.get(
  `${getBffUrl()}/gaio/prompts/statistics`
)

export const fetchGaioPromptOptions = body => Api.post(
  `${getBffUrl()}/gaio/prompts/options`,
  body
)

export const createGaioPrompt = body => Api.post(
  `${getBffUrl()}/gaio/prompts`,
  body
)

export const updateGaioPrompt = (id, body) => Api.patch(
  `${getBffUrl()}/gaio/prompts/${id}`,
  body
)

export const deleteGaioPrompt = (id, body) => Api.destroy(
  `${getBffUrl()}/gaio/prompts/${id}`,
  body
)

export const searchGaioTags = body => Api.post(
  `${getBffUrl()}/gaio/tags/search`,
  body
)

export const fetchGaioSuggestedPrompts = body => Api.post(
  `${getBffUrl()}/gaio/prompts/suggested`,
  body
)

export const fetchGaioPromptNews = (id, page, limit) => Api.get(
  `${getBffUrl()}/gaio/prompts/${id}/news`
  + `?page=${encodeURIComponent(page)}`
  + `&limit=${encodeURIComponent(limit)}`
)

export const searchGaioSources = body => Api.post(
  `${getBffUrl()}/gaio/sources`,
  body
)

export const updateGaioCharts = body => Api.post(
  `${getBffUrl()}/charts/gaio`,
  body
)

export const fetchGaioScorecard = body => Api.post(
  `${getBffUrl()}/gaio/scorecard`,
  body
)

export const requestGaioSubscriptionChange = body => Api.post(
  `${getBffUrl()}/gaio/subscribe`,
  body
)
